import {
    Flex,
    Container,
    Heading,
    Stack,
    Text,
    Button,
    Icon,
    IconProps,
    extendTheme,
    Collapse,
    Box,
    useDisclosure
  } from '@chakra-ui/react';
import Fade from "react-reveal";
import '@fontsource/raleway/600.css';
import '@fontsource/open-sans/400.css';

  const redtheme = extendTheme({
    colors: {
      redyel: {
        100: "#ED9B40", // mellow yellow
        200: "#F6C58E", // pale yellow
        300: "#FFEEDB", // beige white
        400: "#F6D6C2", // pale pink (red 1)
        500: "#ECBEA8", // red 2
        600: "#D88E74", // red 3
        700: "#C45E40", // red 4
        800: "#B02E0C", // bright red (red 5)
        900: "#711E09", // dark dark red (red 6)
        1000: "#230C06" // essentially black w/ red
      },
    },
    fonts: {
        body: `'Open Sans', sans-serif`,
        heading: `'Raleway', sans-serif`,
      },
  });
  
  
  export default function Header() {
    const { isOpen, onToggle } = useDisclosure()

    return (
      <Container maxW={'4xl'} theme={redtheme} >
        <Stack
          textAlign={'center'}
          align={'center'}
          spacing={{ base: 5, sm: 5, md: 8, lg: 10 }}
          py={{ base: 20, md: 20 }}
          px={{ base: 10 }}>
          <Fade bottom>
            <Heading
              fontWeight={600}
              fontSize={{ base: 'xl', sm: '2xl', md: '3xl', lg: '5xl' }}
              color={'redyel.1000'}
              lineHeight={'110%'}>
              Influencer media kits{' '}
              <Text as={'span'} color={'redyel.700'}>
                made easy
              </Text>
            </Heading>
          </Fade>
          <Fade bottom duration={1200}>
            <Text 
              color={'redyel.900'} 
              maxW={'3xl'}
              fontSize={{ base: 'sm', sm: 'sm', md: 'lg', lg: 'xl'}}>
              A customizable media kit generator for influencers (beta vers.) -- no design skills required.
              Just enter your information and download your JPEG!
              </Text>
          </Fade>
          <Fade big delay={15000} duration={2000}>
            <Text 
              color={'redyel.800'} 
              opacity={'0.7'}
              maxW={'3xl'}
              fontSize={{ base: '2vw', sm: '2vw', md: 'sm', lg: 'md'}}
              as={'i'}>
              For optimal photo rendering in your final kit, use this tool on desktop in fullscreen mode.
            </Text>
          </Fade>
          <Fade big delay={15000} duration={2000}>
            <Button 
              onClick={onToggle}
              bg={'redyel.600'}
              color={'redyel.300'}
              minW={'10vw'}
              _hover={{
                  bg: 'redyel.500',
                }} >
                  Guidelines
            </Button>
          </Fade>
            <Collapse in={isOpen} animateOpacity>
                <Box
                  p='40px'
                  color='white'
                  mt='4'
                  bg='redyel.600'
                  rounded='md'
                  shadow='md'
                  maxW='70vw'
                  fontSize='sm'
                >
                This media kit was designed leveraging Instagram Creator metrics, and to complete the required fields and generate your media kit, you’ll need to access to stats under your Professional Dashboard — including reach and audience metrics (such as gender, age range, and location). <br/> <br/>

                Engagement is an important metric for your media kit, and there are many readily available tools for you to calculate your IG engagement rate — I like <a href="https://collabstr.com/instagram-engagement-rate-calculator"><u>Collabstr</u></a> as it’s transparent and free, but feel free to use whichever one you’d like. <br/> <br/>

                Your profile photo should optimally be at an aspect ratio of 11x15 (wxh) — which is not easy to work with, I know 🤧 — so anything narrower than that (10x15, for instance!) will work just fine without distortion. However, it’s important for the overall look of the created media kit that your <b>two additional accent photos are 1:1 (square)</b>. 
                For these accent photos, feel free to choose something that showcases your work on Instagram or TikTok. <br/> <br/>

                Finally, the presentation of this media kit will look best if you maximize the data you provide (aka fill out all the inputs) and if your photos are edited to be on the warmer side as this first color scheme is beige. More colors to come!
                </Box>
            </Collapse>
        </Stack>
      </Container>
    );
    }